import {ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import {Delete, Laptop} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import {formatTaskName} from "../../Service/TaskService";
import HistoryIcon from "@mui/icons-material/History";
import CircularProgress from "@mui/material/CircularProgress";
import {red} from "@mui/material/colors";
import React, {memo} from "react";
import Tooltip from "@mui/material/Tooltip";
import SendTaskButton from "./SendTaskButton";
import Stack from "@mui/material/Stack";
import {areTaskItemPropsEqual} from "./taskItemEquality";

const NO_DELETED_TASKS = [];

// Infobulles à la souris seulement : au doigt, l'appui long sert déjà au glisser-déposer des lignes.

function TaskItem(
    {
        task,
        showMachine = false,
        toDeletedTasks = NO_DELETED_TASKS,
        onSetFirstPosition,
        onPreviewFileTask,
        onTaskSended,
        onRemoveTask,
    }
) {

    const isDtfDtfReferer = task.referer && task.referer.toLowerCase() === 'dtf-dtf';

    return (
        <ListItemButton
            sx={{
                opacity: "1 !important",
                pl: showMachine ? 1 : 0,
                pr: showMachine ? 0.5 : 0,
                backgroundColor: isDtfDtfReferer ? '#ff9800' : 'transparent',
                color: isDtfDtfReferer ? '#000' : 'inherit',
                '&:hover': {
                    backgroundColor: isDtfDtfReferer ? '#ffb74d' : 'rgba(0, 0, 0, 0.04)'
                }
            }}
        >
            {showMachine &&
                <ListItemIcon
                    size="small"
                    sx={{minWidth: 28}}
                >
                    <Tooltip title={"Impression sur la Machine " + task.machine.number} disableTouchListener>
                        <Stack direction="row" gap={1} sx={{pr: 1}}>
                            <Typography variant="subtitle2">{task.machine.number}</Typography>
                            <Laptop fontSize="small"/>
                        </Stack>
                    </Tooltip>
                </ListItemIcon>
            }

            <ListItemText
                primary={
                    <Typography
                        fontSize="small"
                        sx={{
                            display: "block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            paddingLeft: 1,
                            paddingRight: 1,
                        }}
                    >
                        {formatTaskName(task)}
                    </Typography>
                }
                onClick={() => {
                    onPreviewFileTask(task)
                }}
            />

            <ListItemIcon
                size="small"
                sx={{minWidth: 28}}
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    if (onSetFirstPosition) {
                        onSetFirstPosition(task)
                    }
                }}
            >
                <Tooltip title={"Mettre en premier"} disableTouchListener>
                    <HistoryIcon fontSize="small"/>
                </Tooltip>
            </ListItemIcon>

            <ListItemIcon
                disabled={toDeletedTasks.length > 0}
                size="small"
                sx={{minWidth: 28}}
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    onRemoveTask(task)
                }}
            >
                {toDeletedTasks.includes(task.id) &&
                    <CircularProgress
                        size={24}
                        sx={{color: red[500]}}
                    />
                }

                {!toDeletedTasks.includes(task.id) &&
                    <Tooltip title={"Supprimer"} disableTouchListener>
                        <Delete fontSize="small" color="error"/>
                    </Tooltip>
                }
            </ListItemIcon>

            <SendTaskButton
                machine={task.machine}
                onSendTask={(_machine, position) => {
                    onTaskSended(task, _machine, position)
                }}
            />
        </ListItemButton>
    )
}

const MemoizedTaskItem = memo(TaskItem, areTaskItemPropsEqual)

export {MemoizedTaskItem as TaskItem}
